function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}

// Dvisiones
export default [
  {
    path: 'teams',
    name: 'TeamsBack',
    component: loadView('Back/Team/List')
  },
  {
    path: 'teams/:teamId/notices',
    name: 'TeamBackNotices',
    component: loadView('Back/Team/Notices/List')
  },
  {
    path: 'teams/:teamId/notices/create',
    name: 'TeamBackNoticesCreate',
    component: loadView('Back/Team/Notices/Create')
  },
  {
    path: 'teams/:teamId/notices/:noticeId/edit',
    name: 'TeamBackNoticesEdit',
    component: loadView('Back/Team/Notices/Edit')
  },
  {
    path: 'results/home',
    name: 'TeamBackResultsHome',
    component: loadView('Back/Team/Results/Home')
  },
  {
    path: 'results/:fixtureId/:teamId/edit',
    name: 'TeamBackResultsEdit',
    component: loadView('Back/Team/Results/Edit')
  },
  {
    path: 'results/:fixtureId/:teamId/players',
    name: 'TeamBackResultsPlayers',
    component: loadView('Back/Team/Results/Players')
  },
  {
    path: 'results/change',
    name: 'TeamBackResultsChange',
    component: loadView('Back/Team/Results/ChangeResults')
  },
  {
    path: 'results/edit-match/:fixtureId',
    name: 'TeamBackResultsEditMatch',
    component: loadView('Back/Team/Results/EditMatch')
  },
  {
    path: 'results/edit-match/:fixtureId/:teamId/edit-statistics',
    name: 'TeamBackResultsEditMatchStatistics',
    component: loadView('Back/Team/Results/EditStatisticsResult')
  },
  {
    path: 'teams/:teamId',
    name: 'TeamBack',
    component: loadView('Back/Team/Details'),
    children: [
      {
        path: 'managment',
        name: 'TeamBackManagment',
        component: loadView('Back/Team/Managment')
      },
      {
        path: 'tshirts',
        name: 'TeamBackTshirts',
        component: loadView('Back/Team/Tshirts')
      },
      {
        path: 'notifications',
        name: 'TeamBackNotifications',
        component: loadView('Back/Team/Notifications')
      },
      {
        path: 'invitations',
        name: 'TeamBackInvitations',
        component: loadView('Back/Team/Invitations')
      },
      {
        path: 'players',
        name: 'TeamBackPlayers',
        component: loadView('Back/Team/Players')
      },
      {
        path: 'training-show',
        name: 'TeamBackTrainingShow',
        component: loadView('Back/Team/SelectTraining')
      },
      {
        path: 'formation',
        name: 'TeamBackFormation',
        component: loadView('Back/Team/Formation')
      },
      {
        path: 'my-formation',
        name: 'TeamBackMyFormation',
        component: loadView('Back/Team/MyFormation')
      },
      {
        path: 'invite-players',
        name: 'TeamBackMyInvitePlayers',
        component: loadView('Back/Team/InvitePlayers')
      }
    ]
  }
]
